<template>
  <div class="reset-password-container">
    <div class="header-section">
      <div class="logo-section">
        <img src="/favicon.ico" alt="Logo" class="logo-img">
        <div class="logo-text">
          <div class="logo-title">Doneist</div>
          <div class="logo-subtitle">开放平台</div>
        </div>
      </div>
    </div>
    <div class="main-section">
      <el-form :model="forgotPasswordForm" :rules="rules" ref="forgotPasswordForm" label-position="left" label-width="0px" class="reset-password-card">
        <div class="card-content">
          <div class="card-title">找回密码</div>
          <el-form-item prop="email">
            <el-input placeholder="请输入您的邮箱" v-model="forgotPasswordForm.email" prefix-icon="el-icon-message" @keyup.native.enter="sendResetPasswordLink"></el-input>
          </el-form-item>
          <el-form-item prop="verificationCode">
            <div class="code-input-wrapper">
              <el-input class="code-input" placeholder="验证码" v-model="forgotPasswordForm.verificationCode" prefix-icon="el-icon-ice-cream-square" @keyup.native.enter="sendResetPasswordLink"></el-input>
              <el-button type="text" class="send-code-btn" @click="sendVerificationCode">{{sendText}}</el-button>
            </div>
          </el-form-item>
          <el-form-item style="width:100%;">
            <el-button type="primary" id="resetPasswordButton" style="width:100%;" :loading="loading" @click="sendResetPasswordLink">获取新的密码</el-button>
          </el-form-item>
        </div>
        <div class="card-footer">
          <router-link class="login-link" to="/userLogin">
            记得密码了？去登录>>
          </router-link>
        </div>
      </el-form>
    </div>
    <div class="copyright">
      © 2026 Doneist Project. All rights reserved.
      <span class="separator">|</span>
      <el-link target="_blank" class="beian-link" :underline="false" href="https://beian.miit.gov.cn/">备案号：蜀ICP备19030913号-2</el-link>
    </div>
  </div>
</template>

<script>
import {getEmailCodeByResetPassword} from "@/api/systemApi";
import {validateNumInteger} from "@/utils/validateUtil";
export default {
  data() {
    return {
      loading: false,
      forgotPasswordForm: {
        email: '',
        verificationCode:''
      },
      sendText: '发送验证码',
      rules: {
        email: [
          { required: true, message: '请输入邮箱地址', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
        ],
        verificationCode: [{
          validator:validateNumInteger,
          required: true,
          message: '请输入正确的验证码',
          trigger: 'blur'
        }]
      }
    };
  },
  mounted() {
    this.initGeeTest();
  },
  methods: {
    initGeeTest() {
      let _this = this;
      window.initGeetest4({
        captchaId: 'b6c16f2da2ee987963690692e8424dd3',
        product: 'bind',
        protocol: "https://"
      }, function (captcha) {
        window.captcha = captcha;
        captcha.onReady(function () {
        }).onSuccess(function () {
          let result = window.captcha.getValidate();
          let data = _this.forgotPasswordForm;
          data['lotNumber'] = result.lot_number;
          data['captchaOutput'] = result.captcha_output;
          data['passToken'] = result.pass_token;
          data['genTime'] = result.gen_time;
          _this.getEmailCodeByResetPassword(data)
        }).onError(function () {
        }).onClose(function () {
        });
      });
    },
    sendVerificationCode() {
      if (this.forgotPasswordForm.email) {
        this.captchaType = 'getCode'
        window.captcha.showCaptcha();
      } else {
        this.$message.warning('请先输入邮箱地址！');
      }
    },
    getEmailCodeByResetPassword(data) {
      getEmailCodeByResetPassword(data).then(response => {
        if (response.code === 200) {
          this.$message.success('验证码已发送到您的邮箱，请查收！');
        }
      }).catch(() => {
        this.$message.error('发送验证码失败，请稍后再试！');
      });
    },
    sendResetPasswordLink() {
      this.$refs.forgotPasswordForm.validate(valid => {
        if (valid) {
          this.loading = true;
          this.$store.dispatch('user/resetPassword',this.forgotPasswordForm).then(()=>{
            this.loading = false;
            this.forgotPasswordForm.verificationCode="";
            setTimeout(() => {
              this.$router.push('/userLogin').then(()=>{})
            }, 1000);
          }).catch(()=> {
            this.loading = false;
            this.forgotPasswordForm.verificationCode="";
          })
        } else {
          console.log('验证失败!');
          return false;
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.reset-password-container {
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 30%, #f093fb 60%, #4facfe 100%);
  background-attachment: fixed;
}

.header-section {
  padding: 32px 48px;
  flex-shrink: 0;
}

.logo-section {
  display: flex;
  align-items: center;
}

.logo-img {
  width: 48px;
  height: 48px;
  margin-right: 16px;
}

.logo-text {
  display: flex;
  flex-direction: column;
}

.logo-title {
  font-size: 18px;
  font-weight: 700;
  color: #ffffff;
  line-height: 1.2;
}

.logo-subtitle {
  font-size: 16px;
  color: rgba(255, 255, 255, 0.8);
  margin-top: 2px;
}

.main-section {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding-top: 3vh;
  padding-bottom: 32px;
}

@media screen and (min-height: 800px) {
  .main-section {
    padding-top: 10vh;
  }
}

.reset-password-card {
  width: 400px;
  height: 480px;
  background: rgba(255, 255, 255, 0.98);
  backdrop-filter: blur(30px);
  border-radius: 20px;
  padding: 40px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
  border: 1px solid rgba(255, 255, 255, 0.5);
  display: flex;
  flex-direction: column;
}

.card-content {
  flex: 1;
}

.card-footer {
  margin-top: auto;
  padding-top: 10px;
}

.card-title {
  text-align: center;
  font-size: 24px;
  font-weight: 700;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 50%, #f093fb 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin-bottom: 32px;
}

.code-input-wrapper {
  display: flex;
  align-items: center;
  width: 100%;
}

.code-input {
  flex: 1;
  margin-right: 12px;
}

.send-code-btn {
  white-space: nowrap;
  color: #667eea;
  font-weight: 500;
}

.login-link {
  display: block;
  text-align: center;
  font-size: 14px;
  color: #667eea;
  font-weight: 500;
}

#resetPasswordButton {
  font-weight: 600;
  height: 48px;
  border-radius: 12px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4);
  transition: all 0.3s ease;
}

#resetPasswordButton:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(102, 126, 234, 0.5);
}

.copyright {
  text-align: center;
  color: rgba(255, 255, 255, 0.6);
  font-size: 13px;
  padding: 24px 16px;
  flex-shrink: 0;
}

.separator {
  margin: 0 12px;
}

.beian-link {
  color: rgba(255, 255, 255, 0.7);
  font-size: 13px;
}

@media screen and (max-width: 768px) {
  .header-section {
    padding: 20px 24px;
  }

  .logo-img {
    width: 40px;
    height: 40px;
  }

  .reset-password-card {
    width: 100%;
    max-width: 360px;
    padding: 32px 24px;
  }

  .card-title {
    font-size: 20px;
  }

  .copyright {
    font-size: 12px;
  }
}
</style>
